import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnDestroy,
} from '@angular/core';
import { FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { Subject, takeUntil, finalize } from 'rxjs';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { environment } from '../../../../environments/environment';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { BulkService } from '../../service/bulk-service/bulk.service';
import { testingEnum } from '../../common/enum/testingEnum';
import { BaseBulkType } from '../../common/abstract/BaseBulkType';

@Component({
  selector: 'app-bulk-lookup-list-type',
  templateUrl: './bulk-lookup-list-type.component.html',
  styleUrl: './bulk-lookup-list-type.component.scss',
})
export class BulkLookupListTypeComponent
  extends BaseBulkType<FormlyFieldConfig>
  implements OnDestroy
{
  showCode: boolean = false;
  showSearchField: boolean = false;
  lastOrderField: string = 'Name';
  datasource: any[] = [];
  error: string | null = null;
  trackByCode = (_: number, item: any) => item?.code;
  private destroy$ = new Subject<void>();
   override hide: boolean = false;
    override get props(): FormlyFieldProps & { [additionalProperties: string]: any; } {
      return super.props;
    }

  constructor(private injector: Injector, private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.lastOrderField = this.formControl.parent?.get('lastOrder')?.value?this.formControl.parent?.get('lastOrder')?.value:this.lastOrderField;
    this.showSearchField = this.props['showSearchField']? this.props['showSearchField'] == true: false;
    this.showCode = this.props['showCode']? this.props['showCode'] == true: false;
    this.datasource = this.formControl.parent?.get('datasource')?.value;
    this.hide = this.props!.hidden || this.hide;
    this.onOpen();
    this.expandCheckbox();
  }

  onEnter() {
    this.fetch();
  }

  onOpen() {
    if (
      !this.hide &&
      (!this.datasource || this.datasource.length == 0) &&
      !this.showSearchField && (!this.props['functionname'])
    ) {
      this.fetch();
    }
  }

  setOperator(event:any) {
    this.formControl.parent!.get!('operator')?.setValue(event.target.value); 
  }

  private fetch(parameters:any=[]) {
    this.error = null;
    this.loading = true;

    this.resultClear();

    this.datasource = [];
    this.cdr.markForCheck();
    let criteria: string = '';
    if (this.formControl.parent?.get('term')?.value) {
      criteria = this.formControl.parent?.get('operator')?.value + ":" + this.formControl.parent?.get('term')?.value;
    }

    if (this.props['lookupname']) {
      this.injector
        .get(LookupGetService)
        .filter(this.props['lookupname'], criteria, parameters)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loading = false;
            this.cdr.markForCheck();
          })
        )
        .subscribe({
          next: (data) => {
            if (!Array.isArray(data) || data.length === 0) {
              this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `${this.field.props!['label']}: No items found for ${this.formControl.parent?.get('term')?.value?this.formControl.parent?.get('term')?.value:'empty search'}`, life: environment.successElapsedTime });
            }
            this.datasource = (Array.isArray(data) ? [...data] : []).map(
              (opt) => {
              const originalName = opt.name??'-';
                return {
                  code: opt.code,
                  name: `${opt.code} - ${originalName}`,
                  originalName: originalName,
                };
              }
            );

          if (this.datasource && this.datasource.length > environment.maxNumberRowsReturned-1) {
            this.injector!.get(Art57Section).showTooltipMessage({
              severity: 'warn',
              id: testingEnum.maxResultsRetrievedToastMsg,
              detail: `Only ${environment.maxNumberRowsReturned} results were retrieved.  Please refine your search criteria.`,
              life: environment.warningElapsedTime
            });
          }

            this.order(this.showCode == true?this.lastOrderField:'None');
          },
        });
    } else if (this.props['functionname']) {
      const funcion = (this as any)[this.props['functionname']];
      if (typeof funcion === 'function') {
        funcion.call(this); 
      }
    }
  }

  previewfnc(){
    this.injector.get(BulkService).preview(this.field.parent!.parent!.form?.getRawValue())
    .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loading = false;
            this.cdr.markForCheck();
          })
        )
    .subscribe({
          next: (data) => {
            this.resultClear();
            this.datasource = (Array.isArray(data) ? [...data] : []).map(
              (opt) => {
                return {
                  code: opt.code,
                  name: `${opt.code} - ${ opt.name}`,
                  originalName: opt.name,
                };
              }
            );
            if (data.length>999) {
              this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `Only 1000 results were retrieved.  Please refine your filters criteria.`, life: environment.warningElapsedTime });
            }
            this.order(this.showCode == true?this.lastOrderField:'None');
          },
        });

  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  resultClear() {
    this.formControl?.setValue(null);
    this.formControl.parent?.get('datasource')?.setValue([]);
    this.datasource = this.formControl.parent?.get('datasource')?.value;
  }

  override clear() {
    this.formControl.setValue(null);
    this.formControl.parent!.get!('term')!.setValue(null);
    //CHREQ6 clear the resulta and deselect the checkbox
    this.datasource = [];
    this.formControl.parent!.get!('datasource')!.setValue(null);
    this.formControl.parent!.get!('filterStatus')!.setValue(null);
  }

  refresh() {
    this.onEnter();
  }

  override getStatus() {
    this.hasSelectedData = this.formControl != undefined && this.formControl?.value && this.formControl?.value.length > 0;
    this.field.model.hasSelectedData = this.hasSelectedData;
    const status = this.hasSelectedData?'field-filtered':'field-notSelected';
    return status;
  }

  override conmuteHide() {
    this.hide = !this.hide;
    this.onOpen();
  }

  allowedOrderField(): string {
    const allowedOrder = this.lastOrderField === 'Code' ? 'Name' : 'Code';
    return allowedOrder;
  }

  order(orderField: string) {

    if (!this.datasource || this.datasource.length == 0) {
      return;
    }
    switch (orderField) {
      case 'None':
        this.datasource = this.datasource.map((opt) => {
          return {
            code: opt.code,
            name: `${opt.originalName}`,
            originalName: opt.originalName,
          };
        });
        break;
      case 'Code':
        this.datasource = this.datasource.map((opt) => {
          return {
            code: opt.code,
            name: `${opt.code} - ${opt.originalName}`,
            originalName: opt.originalName,
          };
        });
        this.datasource = this.datasource.sort((a, b) => {
          const codeA = a.code;
          const codeB = b.code;

          const isNumA = !isNaN(codeA);
          const isNumB = !isNaN(codeB);

          if (isNumA && isNumB) {
            return Number(codeA) - Number(codeB);
          } else {
            return String(codeA).localeCompare(String(codeB));
          }
        });
        break;
      case 'Name':
        // Build a collator that ignores case (and diacritics if quieres)
        const collator = new Intl.Collator(undefined, {
          sensitivity: 'accent',
          numeric: true,
        });

        this.datasource = this.datasource
          .map((opt) => ({
            code: opt.code,
            name: `${opt.code} - ${opt.originalName}`,
            originalName: opt.originalName,
          }))
          .sort((a, b) =>
            collator.compare(a.originalName ?? '', b.originalName ?? ''),
          );
        break;
    }
    this.lastOrderField = orderField;
    this.formControl.parent?.get('lastOrder')?.setValue(this.lastOrderField);
    this.formControl.parent?.get('datasource')?.setValue(this.datasource);
  }

  override expandCheckbox() {
        const controlStatus = this.field.parent!.get!('filterStatus').formControl;
        if (controlStatus) {
            controlStatus.valueChanges.subscribe((value) => {
                if (value == true) {
                    this.hide = false;
                    this.onOpen();
                } else {
                    this.hide = true;
                }
            });
        }
    }
}
